/**
 * Path for navigating to an entity from lists (submissions, planner, etc.).
 * Omit query so the entity opens on the default VAT tab (consistent across providers).
 */
export const getEntityOrganisationPath = (
  organisationId: string,
  _providerName?: string
): string => {
  return `/entities/organisation/${organisationId}`;
};
